import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "collapse-content" }
const _hoisted_4 = { class: "collapse-content" }
const _hoisted_5 = { class: "collapse-content" }
const _hoisted_6 = { class: "collapse-content" }
const _hoisted_7 = { class: "collapse-content" }
const _hoisted_8 = { class: "collapse-content" }
const _hoisted_9 = { class: "new-form" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_GoldMedal = _resolveComponent("GoldMedal")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_TestItem = _resolveComponent("TestItem")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_Folder = _resolveComponent("Folder")
  const _component_CirclePlusFilled = _resolveComponent("CirclePlusFilled")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_collapse = _resolveComponent("el-collapse")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.TEST,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['TEST_SELECT'] && !_ctx.loading]
        ]),
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "rounded-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse, {
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.activeName) = $event)),
                  accordion: "",
                  ref: "coll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_collapse_item, { name: "1" }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_icon, { size: 32 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_GoldMedal)
                            ]),
                            _: 1
                          })
                        ]),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title-label" }, "Anstehende Prüfungen", -1))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_el_row, { gutter: 20 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testModelList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_col, {
                                  span: 8,
                                  class: "test-col"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_TestItem, {
                                      model: item,
                                      onOnTestEdit: _ctx.onTestEdit,
                                      onOnTestDelete: _ctx.onTestDelete
                                    }, null, 8, ["model", "onOnTestEdit", "onOnTestDelete"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 256))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_collapse_item, { name: "2" }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_el_icon, { size: 32 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Folder)
                            ]),
                            _: 1
                          })
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title-label" }, "Archivierte Prüfungen", -1))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_row, { gutter: 20 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testModelArchiveList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_col, {
                                  span: 8,
                                  class: "test-col"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_TestItem, {
                                      model: item,
                                      onOnTestEdit: _ctx.onTestEdit,
                                      onOnTestDelete: _ctx.onTestDelete
                                    }, null, 8, ["model", "onOnTestEdit", "onOnTestDelete"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 256))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.hasPermission['TEST_INSERT'])
                      ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                          key: 0,
                          name: "3"
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CirclePlusFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-label" }, "Neue Prüfung", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_el_form, {
                                  ref: "newTestForm",
                                  rules: _ctx.rules,
                                  "label-position": "top",
                                  model: _ctx.newTestModel,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    (!_ctx.isCustomer)
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 0,
                                          label: "Mandant",
                                          prop: "customerid"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: _ctx.newTestModel.customerid,
                                              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.newTestModel.customerid) = $event)),
                                              onChange: _ctx.onInput,
                                              placeholder: "Bitte wählen ..."
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerModelList, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item.customerid,
                                                    label: item.name,
                                                    value: item.customerid
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "onChange"])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_el_form_item, {
                                      label: "Bezeichnung",
                                      prop: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newTestModel.name,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.newTestModel.name) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "Datum" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: _ctx.testDate,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.testDate) = $event)),
                                          type: "datetime",
                                          placeholder: "Bitte wählen...",
                                          format: "DD.MM.YYYY HH:mm",
                                          onChange: _ctx.onInput
                                        }, null, 8, ["modelValue", "onChange"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Zielgruppe",
                                      prop: "targetgroupid"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.newTestModel.targetgroupid,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.newTestModel.targetgroupid) = $event)),
                                          placeholder: "Bitte wählen...",
                                          onChange: _ctx.onInput
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetGroupList, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.targetgroupid,
                                                label: item.name,
                                                value: item.targetgroupid
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "onChange"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Notizen",
                                      prop: "note"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.newTestModel.note,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.newTestModel.note) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formValid,
                                          onClick: _ctx.onNewTestClick
                                        }, {
                                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                                            _createTextVNode("Hinzufügen")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.hasPermission['TEST_SELECT']]
        ])
      ])
    ])
  ], 64))
}